import T from 'prop-types';

import {
  frameShape
} from 'arts/reducers/work';

export const selectionShape = T.shape({
  frame: frameShape
});
